import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25\"><form class=\"search-box position-relative\"><input type=\"text\" class=\"form-control shadow-none text-black rounded-0 border-0\" placeholder=\"Search product\"><button type=\"submit\" class=\"bg-transparent text-primary transition p-0 border-0\"><i class=\"flaticon-search-interface-symbol\"></i></button></form><div class=\"d-sm-flex align-items-center\"><a class=\"default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none\" href=\"#\" data-bs-toggle=\"modal\" data-bs-target=\"#AddElementModal\"><i class=\"flaticon-plus position-relative ms-5 fs-12\"></i> Ajouter un utilisateur </a><button class=\"default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0\" type=\"button\"> Export <i class=\"flaticon-file-1 position-relative ms-5 top-2 fs-15\"></i></button></div></div>", 1)
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " nom complet "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " telephone "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Type "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Actions ")
  ])
], -1)
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_20 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddUtilisateurModal = _resolveComponent("AddUtilisateurModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (el, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(el.id), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString((el.nom) ? el.nom : '') + " " + _toDisplayString((el.prenoms) ? el.prenoms : ''), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString((el.telephone) ? el.telephone : ''), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString((el.email) ? el.email : ''), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge rounded-pill", {
                      'bg-warning text-dark': el.type === 'Abonne',
                      'bg-success': el.type === 'Administrateur'
                    }])
                    }, _toDisplayString((el?.type) ? el.type : ''), 3)
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("ul", _hoisted_15, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddElementModal",
                            onClick: ($event: any) => (_ctx.modification(el))
                          }, [
                            _hoisted_17,
                            _createTextVNode(" Modifier ")
                          ], 8, _hoisted_16)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(el.id,_ctx.elements,'utilisateur','ce utilisateur'))
                          }, [
                            _hoisted_19,
                            _createTextVNode(" Desactivé ")
                          ], 8, _hoisted_18)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddUtilisateurModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger
    }, null, 8, ["item", "onClose"])
  ], 64))
}